<template>
  <div class="animated fadeIn" id="list-assures">
    <transition name="fade">
      <b-card no-body>
        <div slot="header">
          <i class="fa fa-search mr-2"></i>
          <strong>Recherche</strong>
          <div class="card-header-actions">
            <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1>
              <span class="when-opened">
                <i class="icon-arrow-down"></i>
              </span>
              <span class="when-closed">
                <i class="icon-arrow-up"></i>
              </span>
            </b-link>
          </div>
        </div>
        <b-collapse id="collapse1" visible>
          <b-card-body>
            <b-card>
              <b-form v-on:submit.prevent="search">
                <b-row>
                  <b-col sm="4">
                    <b-form-group >
                      <label for="nir"><strong>NIR</strong></label>
                      <b-form-input type="text" id="nir" v-model="nir_criteria" :class="{hasError: errors.nir_criteria !== ''}"></b-form-input>
                      <span class="field-error">{{ errors.nir_criteria }}</span>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group >
                      <label for="nom"><strong>Nom</strong></label>
                      <b-form-input type="text" id="nom" v-model="nom_criteria"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group >
                      <label for="prenom"><strong>Prénom</strong></label>
                      <b-form-input type="text" id="prenom" v-model="prenom_criteria"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="4">
                    <b-form-group >
                      <label for="num_dossier"><strong>N° Dossier ATLAS</strong></label>
                      <b-form-input type="text" id="num_dossier" v-model="dossier_criteria" :class="{hasError: errors.dossier_criteria !== ''}"></b-form-input>
                      <span class="field-error">{{ errors.dossier_criteria }}</span>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group >

                      <label for="siren"><strong>SIREN</strong></label>
                      <b-form-input type="text" id="siren" v-model="siren_criteria" :class="{hasError: errors.siren_criteria !== ''}"></b-form-input>
                      <span class="field-error">{{ errors.siren_criteria }}</span>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group >

                      <label for="email"><strong>Email (Bénéficiaire)</strong></label>
                      <b-form-input type="text" id="email" v-model="email_criteria" :class="{hasError: errors.email_criteria !== ''}"></b-form-input>
                      <span class="field-error">{{ errors.email_criteria }}</span>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group >
                      <label for="email"><strong>Source</strong></label>
                      <b-form-select id="source" v-model="source">
                        <option v-for="opt in sourceOptions"
                                :key="opt.value"
                                :value="opt.value">
                          {{ opt.text }}
                        </option>
                      </b-form-select>
                      <span class="field-error">{{ errors.source_type }}</span>
                    </b-form-group>
                  </b-col>
                </b-row>
                <div slot="footer">
                  <b-button type="button" @click.prevent="clearForm()" size="md" variant="secondary" class="mr-1">
                    <i class="fa fa-eraser"></i> Effacer
                  </b-button>
                  <b-button type="enter" @click.prevent="search()" size="md" variant="primary">
                    <i class="fa fa-search"></i> Rechercher
                  </b-button>
                </div>
              </b-form>
            </b-card>
          </b-card-body>
        </b-collapse>
      </b-card>
    </transition>
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i>
        <strong>Liste des assurés</strong>
      </b-card-header>
      <b-card-body>
        <assure-table :tableEntry="tableParam" ref="assure_table"></assure-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import AssureTable from '../../../components/AssureTable'
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../utils/auth";

  export default {
    name: "List",
    components: { AssureTable },
    data() {
      return {
        dossier_criteria: '',
        nir_criteria: '',
        siren_criteria: '',
        nom_criteria: '',
        prenom_criteria: '',
        email_criteria: '',
        noSearch: 'noSearch',
        source: "tous",
        // tableau options source
        sourceOptions: [
          {value: "tous", text: "Tous"},
          {value: "beneficiaire", text: "Bénéficiaires"},
          {value: "assure", text: "Assurés"},
        ],
        errors: {
          dossier_criteria: '',
          nir_criteria: '',
          siren_criteria: '',
          email_criteria: '',
          source_type: ''
        }
      };
    },

    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();

      if (this.$route.query.do) {
        this.dossier_criteria = this.$route.query.do
      }

      if (this.$route.query.ns) {
        this.nir_criteria = this.$route.query.ns
      }
      if (this.$route.query.no) {
        this.nom_criteria = this.$route.query.no
      }
      if (this.$route.query.pr) {
        this.prenom_criteria = this.$route.query.pr
      }
      if (this.$route.query.siren) {
        this.siren_criteria = this.$route.query.siren
      }
      if (this.$route.query.email) {
        this.email_criteria = this.$route.query.email
      }
      // Si co alors retour d'une fiche suite à recherche, donc noSearch vide
      if (this.$route.query.co) {
        this.noSearch = ''
      }
      // ici on passe le param source à la route
      if (this.$route.query.source) {
        this.source = this.$route.query.source;
      }
    },
    computed: {
      tableParam: {
        get() {
          let request = {};
          request.dossier_criteria = this.dossier_criteria.replace(/ /g, "")
          this.dossier_criteria = request.dossier_criteria
          request.nir_criteria = this.nir_criteria.replace(/ /g, "")
          this.nir_criteria = request.nir_criteria
          request.nom_criteria = this.nom_criteria;
          request.prenom_criteria = this.prenom_criteria;
          request.siren_criteria = this.siren_criteria.replace(/ /g, "")
          request.email_criteria = this.email_criteria;
          this.siren_criteria = request.siren_criteria
          this.email_criteria = request.email_criteria
          request.noSearch = this.noSearch;
          request.source = this.source;
          this.source = request.source;
          return request;
        }
      },
    },
    methods: {
      search() {
        if (this.validateData()) {
          this.$store.commit("IS_LOADING", true);
          this.noSearch = '';
          setTimeout(this.$refs.assure_table.$refs.table.refresh(), 3000);
        }
      },
      validateData() {
        this.clearErrors()
        let regNumeric = this.$store.getters.getRegNumeric
        let valid = true;
        let num_dossier = this.dossier_criteria.replace(/ /g, "")
        if (num_dossier !== '') {
          if (!regNumeric.test(num_dossier)) {
            this.errors.dossier_criteria = 'Un N° Dossier ne doit contenir que des chiffres'
            valid = false
          }
        }
        let nir = this.nir_criteria.replace(/ /g, "")
        if (nir !== '') {
          // if (!regNumeric.test(nir)) {
          //   this.errors.nir_criteria = 'Un NIR ne doit contenir que des chiffres'
          //   valid = false
          // }
          // else if (nir.length > 15 || nir.length < 13) {
          if (nir.length > 15 || nir.length < 13) {
            this.errors.nir_criteria = 'Un NIR doit contenir soit 13 soit 15 chiffres'
            valid = false
          }
        }
        let siren = this.siren_criteria.replace(/ /g, "")
        if (siren !== '') {
          if (!regNumeric.test(siren)) {
            this.errors.siren_criteria = 'Un SIREN ne doit contenir que des chiffres'
            valid = false
          }
        }

        // Validation selected SOurce
        const allowedSources = this.sourceOptions.map(opt => opt.value)
        if (!allowedSources.includes(this.source)) {
          this.errors.source_type = 'Veuillez sélectionner une source valide'
          valid = false
        }
        return valid
      },
      clearErrors() {
        this.errors.dossier_criteria = ''
        this.errors.nir_criteria = ''
        this.errors.siren_criteria = ''
        this.errors.email_criteria = ''
        this.errors.source_type = ''
      },
      formatDate(textDate) {
        return textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      },
      formatNir(textNir) {
        if(textNir !== null  && textNir.length === 15){
          return textNir.substring(0,13);
        } else {
          return textNir;
        }
      },
      clearForm() {
        this.dossier_criteria = ''
        this.nir_criteria = ''
        this.nom_criteria = ''
        this.prenom_criteria = ''
        this.siren_criteria = ''
        this.email_criteria = ''
        this.source = 'tous'
      }
    }
  };
</script>

<style>
  .collapsed > .when-opened,
  :not(.collapsed) > .when-closed {
    display: none;
  }

  #list-assures .VueTables__table thead tr th:first-child {
    width: 10%;
  }
  #list-assures .VueTables__table thead tr th:nth-child(2) {
    width: 10%;
  }
  #list-assures .VueTables__table thead tr th:nth-child(3) {
    width: 27%;
  }
  #list-assures .VueTables__table thead tr th:nth-child(4) {
    width: 26%;
  }
  #list-assures .VueTables__table thead tr th:nth-child(5) {
    width: 10%;
  }
  #list-assures .VueTables__table thead tr th:nth-child(6) {
    width: 10%;
  }
  #list-assures .VueTables__table thead tr th:nth-child(7) {
    width: 7%;
  }
</style>

